import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import {
  LoginChangeTemporaryPasswordFormComponent,
  LoginFormComponent,
  LoginResetPasswordFormComponent,
  LoginSelectProfileComponent,
  LoginSendCodeFormComponent,
  LoginShellComponent
} from '@iot-platform/auth';
import { BusinessProfile } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [
    TranslatePipe,
    MatIconModule,
    MatCardModule,
    LoginFormComponent,
    LoginChangeTemporaryPasswordFormComponent,
    LoginSendCodeFormComponent,
    LoginResetPasswordFormComponent,
    LoginSelectProfileComponent
  ],
  selector: 'oyan-ui-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent extends LoginShellComponent {
  authPending: Signal<boolean> = this.authFacade.authPending;
  eligibleBusinessProfiles: Signal<BusinessProfile[]> = this.authFacade.eligibleBusinessProfiles;
}
